import { useState, useEffect, useCallback } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { sportsCategories } from '@/mocks/data';

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  const handleScroll = useCallback(() => {
    setScrolled(window.scrollY > 50);
  }, []);

  useEffect(() => {
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, [handleScroll]);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled
          ? 'bg-background-50/95 backdrop-blur-md shadow-sm'
          : 'bg-transparent'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-2xl font-heading font-bold text-primary-500">
              BB<span className="text-foreground-900">体育</span>
            </span>
          </Link>

          <div className="hidden lg:flex items-center gap-8">
            <Link
              to="/"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              首页
            </Link>
            {sportsCategories.slice(0, 4).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors whitespace-nowrap ${
                  location.pathname === `/category/${cat.slug}`
                    ? 'text-primary-500'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {cat.name}
              </Link>
            ))}
            <Link
              to="/category/promotions"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/category/promotions'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              优惠活动
            </Link>
            <Link
              to="/about"
              className={`text-sm font-medium transition-colors whitespace-nowrap ${
                location.pathname === '/about'
                  ? 'text-primary-500'
                  : 'text-foreground-700 hover:text-primary-500'
              }`}
            >
              关于我们
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <Link
              to="/about"
              className="px-4 py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap"
            >
              登录
            </Link>
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className="lg:hidden w-10 h-10 flex items-center justify-center text-foreground-700"
            aria-label="菜单"
          >
            <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {mobileOpen && (
        <div className="lg:hidden bg-background-50 border-t border-background-200">
          <div className="px-4 py-3 flex flex-col gap-2">
            <Link to="/" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">首页</Link>
            {sportsCategories.map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">
                {cat.name}赛事
              </Link>
            ))}
            <Link to="/category/promotions" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">优惠活动</Link>
            <Link to="/about" className="py-2 text-sm font-medium text-foreground-700 hover:text-primary-500 whitespace-nowrap">关于我们</Link>
            <div className="flex gap-3 pt-3 border-t border-background-200">
              <Link to="/about" className="flex-1 py-2 text-center text-sm font-medium border border-background-300 rounded-md text-foreground-700 hover:bg-background-100 transition-colors whitespace-nowrap">登录</Link>
              <Link to="/about" className="flex-1 py-2 text-center text-sm font-medium bg-primary-500 text-background-50 rounded-md hover:bg-primary-600 transition-colors whitespace-nowrap">立即注册</Link>
            </div>
          </div>
        </div>
      )}
    </nav>
  );
}